const householdObjects = {
  name: "Household Objects",
  prompts: [
    "Cupboard",
    "Pillow",
    "Coffee maker",
    "Bed",
    "Spoon",
    "Blanket",
    "Knife",
    "Stove",
    "Sink",
    "Washing machine",
    "Pot",
    "Dish",
    "Fridge",
    "Sofa",
    "Stool",
    "Cup",
    "Fork",
    "Glass",
    "Car",
    "Bicycle",
    "Banknote",
    "Wallet",
    "Blouse",
    "Bag",
    "Shirt",
    "Helmet",
    "Toothbrush",
    "Key",
    "Table",
    "Coin",
    "Shoe",
    "Jacket",
  ],
};

export default householdObjects;
